<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <kgr-accordion>
                <kgr-accordion-item :open="false">
                    <template #header-left>
                        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                            {{ $t('Rechnungslauf') }}
                        </h3>
                        <div
                            v-if="thisMemberInvoicingRunning || disabled || clubInvoicingRunning"
                            class="kgr-text kgr-text--extraSmall"
                        >
                            {{ message }}
                        </div>
                    </template>
                    <div
                        v-if="loading"
                        class="kgr-postfix__fluid"
                    >
                        <kgr-loader />
                    </div>
                    <div
                        v-if="showAlert"
                        class="kgr-alert kgr-alert--info kgr-row kgr-postfix kgr-postfix--gutters kgr-postfix--top"
                    >
                        <div
                            class="kgr-postfix__fluid"
                        >
                            <div v-show="!loading">
                                {{ message }}
                            </div>
                        </div>
                        <div
                            v-show="!loading"
                            class="kgr-postfix__fixed"
                        >
                            <button
                                class="kgr-button kgr-button--accent"
                                @click="loadStatus()"
                            >
                                {{ $t('Status überprüfen') }}
                            </button>
                        </div>
                    </div>
                    <div v-if="showContainer">
                        <div class="kgr-inputGroup">
                            <div class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters">
                                <div class="kgr-grid__cell">
                                    <kgr-form-row
                                        :label="$t('Start')"
                                        :error="error"
                                        field-name="start"
                                    >
                                        <kgr-date-picker
                                            v-model="start"
                                        />
                                    </kgr-form-row>
                                </div>
                                <div class="kgr-grid__cell">
                                    <kgr-form-row
                                        :label="$t('Ende')"
                                        :error="error"
                                        field-name="end"
                                    >
                                        <kgr-date-picker
                                            v-model="end"
                                        />
                                    </kgr-form-row>
                                </div>
                            </div>
                        </div>
                        <hr class="kgr-separator--light" />
                        <div class="kgr-inputGroup">
                            <div class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters">
                                <div class="kgr-grid__cell">
                                    <kgr-checkbox
                                        v-model="clearConsumer"
                                        :label="$t('Gebühren des Mitglieds abrechnen')"
                                    />
                                </div>
                                <div
                                    class="kgr-grid__cell"
                                >
                                    <kgr-checkbox
                                        v-model="clearInvoiceRecipient"
                                        :label="$t('Gebühren abrechnen, für die das Mitglied als Rechnungsempfänger eingetragen ist')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="kgr-inputGroup">
                            <div class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters">
                                <div class="kgr-grid__cell">
                                    <kgr-generic-radio
                                        v-model="feeRadio"
                                        :options="feeOptions"
                                    />
                                </div>
                                <div
                                    v-if="feeRadio"
                                    class="kgr-grid__cell"
                                >
                                    <div
                                        v-if="feeRadio"
                                        class="kgr-row"
                                    >
                                        <table
                                            class="kgr-table kgr-table--block kgr-table--striped printable"
                                        >
                                            <thead>
                                                <tr class="kgr-table__row">
                                                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print">
                                                        <kgr-checkbox
                                                            :label="$t('Alle auswählen')"
                                                            :checked="allChecked"
                                                            @change="toggleAll()"
                                                        />
                                                    </th>
                                                    <th class="kgr-table__cell kgr-table__cell--headline">
                                                        {{ $t('Name') }}
                                                    </th>
                                                    <th class="kgr-table__cell kgr-table__cell--headline">
                                                        {{ $t('Kategorie') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="fee in clubFees"
                                                    :key="fee.id"
                                                    class="kgr-table__row"
                                                >
                                                    <td class="kgr-table__cell">
                                                        <kgr-checkbox
                                                            :checked="isSelected(fee.id)"
                                                            @change="toggleFee(fee.id)"
                                                        />
                                                    </td>
                                                    <td class="kgr-table__cell">
                                                        {{ fee.name }}
                                                    </td>
                                                    <td class="kgr-table__cell">
                                                        {{ fee.category }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="kgr-separator--light" />
                        <div class="kgr-row kgr-text--rightAligned">
                            <button
                                class="kgr-button kgr-button--accent"
                                :disabled="buttonDisabled"
                                @click="invoice"
                            >
                                {{ $t('Rechnungslauf starten') }}
                            </button>
                        </div>
                    </div>
                </kgr-accordion-item>
            </kgr-accordion>
        </div>
        <hr
            class="kgr-separator--light"
        />
        <kgr-member-invoices
            :id="id"
            :club-id="clubId"
        />
    </div>
</template>

<script>
import { endOfMonth, format, parse, startOfMonth } from '@legacy/js/date/date-fns.js';
import Accordion from '../../../components/common/accordion/Accordion.vue';
import AccordionItem from '../../../components/common/accordion/AccordionItem.vue';
import Checkbox from '../../../components/common/form/checkbox/Checkbox.vue';
import ClubRepository from '../../../js/repository/ClubRepository.js';
import DatePicker from '../../../components/common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import GenericRadio from '../../../components/common/form/radio/GenericRadio.vue';
import Helper from '../../../js/accounting/Helper.js';
import Loading from '../../../components/common/Loading.vue';
import MemberClubFeeRepository from '../../../js/repository/MemberClubFeeRepository.js';
import MemberInvoices from './MemberInvoices.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
        'kgr-loader': Loading,
        'kgr-checkbox': Checkbox,
        'kgr-generic-radio': GenericRadio,
        'kgr-member-invoices': MemberInvoices,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            feeOptions: {
                'Alle Beiträge': false,
                'Beiträge auswählen': true,
            },
            feeRadio: false,
            reloadTimerInSeconds: 5,
            loading: false,
            clubInvoicingRunning: false,
            thisMemberInvoicingRunning: false,
            disabled: false,
            club: null,
            clearConsumer: false,
            clearInvoiceRecipient: false,
            helper: new Helper(),
            selected: [],
            clubFees: [],
            start: format(startOfMonth(new Date()), 'dd.MM.yyyy'),
            end: format(endOfMonth(new Date()), 'dd.MM.yyyy'),
        };
    },
    computed: {
        message() {
            if (this.disabled) {
                return this.$t('Der Rechnungslauf ist für kurze Zeit deaktiviert. Bitte versuche es in wenigen Minuten noch einmal.');
            }
            if (this.clubInvoicingRunning) {
                return this.$t('Der Rechnungslauf des Vereins wurde gestartet. Bitte hab einen Moment Geduld...');
            }
            if (this.thisMemberInvoicingRunning) {
                return this.$t('Es läuft bereits ein Rechnungslauf für dieses Mitglied. Bitte hab einen Moment Geduld...');
            }
            return this.$t('Etwas unerwartetes ist passiert.');
        },
        showAlert() {
            return !this.loading && (this.clubInvoicingRunning || this.disabled || this.thisMemberInvoicingRunning);
        },
        showContainer() {
            return !this.loading && !this.clubInvoicingRunning && !this.disabled && !this.thisMemberInvoicingRunning;
        },
        buttonDisabled() {
            return this.loading || (!this.clearConsumer && !this.clearInvoiceRecipient) || (this.feeRadio && this.selected.length === 0);
        },
        invoiceRecipientDisabled() {
            return this.memberInvoicingRunning;
        },
        allChecked() {
            const allIds = this.clubFees.map((f) => f.id);
            return allIds.length > 0 && allIds.every((id) => this.selected.includes(id));
        },
    },
    created() {
        this.loadClub();
        this.loadStatus();
        this.loadFees();
    },
    methods: {
        toggleAll() {
            const allIds = this.clubFees.map((f) => f.id);
            if (this.allChecked) {
                this.selected = [];
            } else {
                this.selected = [...allIds];
            }
        },
        isSelected(feeId) {
            return this.selected.includes(feeId);
        },
        toggleFee(feeId) {
            const idx = this.selected.indexOf(feeId);
            if (idx === -1) {
                this.selected.push(feeId);
            } else {
                this.selected.splice(idx, 1);
            }
        },
        getPrice(fee) {
            return this.helper.getPricePerTime(fee.priceHistory.getCurrentPricePerTime());
        },
        invoice() {
            this.loading = true;
            const params = {
                clearConsumer: this.clearConsumer,
                clearInvoiceRecipient: this.clearInvoiceRecipient,
            };
            if (this.feeRadio) {
                params.fees = this.selected;
            }
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const formattedStart = format(start, 'yyyy-MM-dd');
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            const formattedEnd = format(end, 'yyyy-MM-dd');
            axios
                .post(`/club/members/${this.id}/invoice-asset-prototypes?accountingPeriod=${formattedStart}:${formattedEnd}`, params)
                .then(() => this.loadStatus());
        },
        loadClub() {
            ClubRepository.getClub(this.clubId).then((club) => this.club = club);
        },
        loadStatus() {
            this.loading = true;
            axios
                .get(`/club/members/${this.id}/invoicing`)
                .then((response) => {
                    this.clubInvoicingRunning = response.data.data.isClubInvoiceRunning;
                    this.disabled = response.data.data.isDisabled;
                    this.thisMemberInvoicingRunning = response.data.data.isThisMemberInvoiceRunning;
                    this.loading = false;
                    if (this.clubInvoicingRunning || this.thisMemberInvoicingRunning) {
                        setTimeout(this.loadStatus, this.reloadTimerInSeconds * 1000);
                    }
                });
        },
        loadFees() {
            this.loading = true;
            const calls = [
                MemberClubFeeRepository.findByMemberAndDefaultContext(this.id),
                MemberClubFeeRepository.findByInvoiceRecipientAndDefaultContext(this.id),
            ];
            Promise.all(calls).then((response) => {
                const allMemberClubFees = response[0].concat(response[1]);
                // turn memberClubFees into distinct clubFees
                this.clubFees = allMemberClubFees.map((memberClubFee) => {
                    return {
                        id: memberClubFee.clubFeeId,
                        name: memberClubFee.clubFee,
                        category: memberClubFee.clubFeeCategory,
                    };
                }).filter((item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id),
                );
                this.loading = false;
            },
            );
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
